<template>
  <!-- begin #header -->
  <div id="header" class="header navbar navbar-default navbar-fixed-top">
    <!-- begin container-fluid -->
    <div class="container-fluid">
      <!-- begin mobile sidebar expand / collapse button -->
      <div class="navbar-header" v-if="th === 'old'">
        <a href="javascript:;" class="navbar-brand"><img :src="logo" style="width: 30px"/> {{ title }}</a>
        <button type="button" class="navbar-toggle" data-click="sidebar-toggled">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <div class="navbar-header" v-if="th === 'new'">
        <a href="javascript:;" class="navbar-brand"><img :src="'https://www.nfjuara.id/wp-content/uploads/2021/08/logo-nf.png'" style="width: 100px"/> &nbsp;Admin</a>
        <button type="button" class="navbar-toggle" data-click="sidebar-toggled">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <!-- end mobile sidebar expand / collapse button -->

      <!-- begin header navigation right -->
      <ul class="nav navbar-nav navbar-right">
        <li class="dropdown navbar-user">
          <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
            <img :src="this.picture" alt="avatar" v-on:error="this.src='~@/assets/img/avatar-default.svg'" />
            <span class="hidden-xs">{{ username }}</span> <b class="caret"></b>
          </a>
          <ul class="dropdown-menu animated fadeInLeft">
            <li class="arrow"></li>
            <li><a href="javascript:;" v-on:click="changeTheme">Change Theme</a></li>
            <li><a href="javascript:;" v-on:click="handleLogout">Log Out</a></li>
          </ul>
        </li>
      </ul>
      <!-- end header navigation right -->
    </div>
    <!-- end container-fluid -->
  </div>
  <!-- end #header -->
</template>

<script>
import auth from '@/services/auth.js'
import logo from '@/assets/img/launcher.png'

export default {
  name: 'app-header',
  data() {
    return {
      title: 'NFJuara Admin',
      logo: logo,
      th: sessionStorage.getItem('theme') ? sessionStorage.getItem('theme') : 'old'
    }
  },
  computed: {
    picture() {
      return this.$ls.get('profiles').picture
    },
    username() {
      return this.$ls.get('profiles').email
    }
  },
  methods: {
    changeTheme(){
      if(sessionStorage.getItem('theme') === 'new') sessionStorage.setItem('theme', 'old')
      else sessionStorage.setItem('theme', 'new')
      location.reload()
    },
    handleLogout() {
      var token = localStorage.getItem('jwtToken')
      var context = this
      auth.doLogout(token, function (result) {
        if (result.success) {
          context.$ls.clear()
          context.$store.commit('auth_destroyed')
          context.$router.push('/')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?aef85adc